import type { Project, PortfolioCategory } from "./types";

/** The "3D" sub-category of Websites (slug variants tolerated). */
const isExcludedSlug = (s: string) => {
  const v = s.trim().toLowerCase();
  return v === "3d" || v === "3-d" || v.startsWith("3d-");
};
const isExcludedLabel = (l: string) => {
  const v = l.trim().toLowerCase();
  return v === "3d" || v === "3-d" || v.startsWith("3d ");
};


export function isThreeDProject(p: Project): boolean {
  return (
    (p.categorySlugs?.some(isExcludedSlug) ?? false) ||
    (p.categoryLabels?.some(isExcludedLabel) ?? false) ||
    isExcludedLabel(p.categoryLabel ?? "")
  );
}

export function excludeThreeD(projects: Project[]): Project[] {
  return projects.filter((p) => !isThreeDProject(p));
}

export function excludeThreeDCategories(categories: PortfolioCategory[]): PortfolioCategory[] {
  return categories.filter((c) => !isExcludedSlug(c.slug) && !isExcludedLabel(c.name));
}
